import React from 'react';
import { THEME_COLORS } from '../data/mockData';
import { Check } from 'lucide-react';
interface ThemeColorPickerProps {
  currentColor: string;
  onChange: (color: string) => void;
}
export function ThemeColorPicker({
  currentColor,
  onChange
}: ThemeColorPickerProps) {
  return <div className="flex flex-col gap-3 p-4" data-id="element-243">
      <span className="text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-244">
        Theme Color
      </span>
      <div className="flex gap-2 flex-wrap" data-id="element-245">
        {THEME_COLORS.map(color => <button key={color.id} onClick={() => onChange(color.value)} className="w-6 h-6 rounded-full flex items-center justify-center transition-transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#1A1A1A] focus:ring-white" style={{
        backgroundColor: color.value
      }} aria-label={`Select ${color.id} theme`} data-id="element-246">
            {currentColor === color.value && <Check className="w-3.5 h-3.5 text-white" strokeWidth={3} data-id="element-247" />}
          </button>)}
      </div>
    </div>;
}